/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-association.reducer';

export const DoctorAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorAssociationEntity = useAppSelector(state => state.doctorAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorAssociation.detail.title">DoctorAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.id}</dd>
          <dt>
            <span id="joiningDate">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.joiningDate">Joining Date</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.joiningDate}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.cursor}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.doctorAssociation.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{doctorAssociationEntity.registrationCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAssociation.medicalAssociation">Medical Association</Translate>
          </dt>
          <dd>{doctorAssociationEntity.medicalAssociation ? doctorAssociationEntity.medicalAssociation.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAssociation.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorAssociationEntity.doctor ? doctorAssociationEntity.doctor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-association/${doctorAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorAssociationDetail;
